import React from "react";
import { siteData } from "../data/mock";
import { Landmark, TrendingUp, UserCircle2, Trophy, User, Award, CheckCircle2 } from "lucide-react";

const iconMap = { Landmark, TrendingUp, UserCircle2, Trophy };

const Instructor = () => {
  const { instructor } = siteData;
  return (
    <section id="speaker" className="py-16 sm:py-20 lg:py-32 relative overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(700px 500px at 20% 30%, rgba(30,90,160,0.28), transparent 60%)",
        }}
      />
      <div className="max-w-[1280px] mx-auto px-5 sm:px-6 lg:px-10 relative">
        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-14 lg:gap-14 items-start">
          {/* Image column */}
          <div className="relative">
            <div className="card-glow rounded-2xl overflow-hidden aspect-[4/5] relative">
              <img
                src={instructor.image}
                alt="Kent Oliver Bhupathi"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050a18] via-transparent to-transparent" />
            </div>
            <div className="absolute -bottom-4 left-6 right-6 card-glow rounded-xl p-4 flex items-center justify-between">
              <div>
                <div className="flex items-center gap-2 text-[10px] tracking-[0.28em] uppercase text-[#5EC7F5]">
                  <User className="w-3.5 h-3.5" /> {instructor.experienceLabel}
                </div>
                <div className="text-white text-sm font-medium mt-1">
                  {instructor.experienceName}
                </div>
              </div>
              <div className="text-right">
                <div className="flex items-center gap-2 text-[10px] tracking-[0.28em] uppercase text-slate-400 justify-end">
                  <Award className="w-3.5 h-3.5" /> Experience
                </div>
                <div className="text-white text-sm font-medium mt-1">
                  {instructor.experienceYears}
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div>
            <div className="flex items-center gap-3">
              <span className="eyebrow-line" />
              <span className="text-[11px] tracking-[0.32em] uppercase text-[#5EC7F5]">
                {instructor.eyebrow}
              </span>
              <span className="eyebrow-line" />
            </div>
            <h2 className="font-display text-[40px] sm:text-[48px] md:text-[56px] lg:text-[64px] leading-[0.98] mt-6 text-gradient-title uppercase">
              {instructor.firstName}
            </h2>
            <p className="font-display text-[32px] sm:text-[40px] md:text-[48px] lg:text-[54px] text-gradient-blue leading-none uppercase tracking-tight">
              {instructor.lastName}
            </p>
            <p className="text-[#5EC7F5] text-[12px] sm:text-[13px] tracking-[0.22em] sm:tracking-[0.24em] uppercase mt-5">
              {instructor.role}
            </p>

            <div className="mt-6 h-px divider-line" />

            <p className="text-slate-300/80 text-[15px] leading-relaxed mt-6">
              {instructor.bio1}
            </p>
            <p className="text-slate-300/80 text-[15px] leading-relaxed mt-4">
              {instructor.bio2}
            </p>

            <div className="mt-8 space-y-3">
              {instructor.credentials.map((c) => {
                const Icon = iconMap[c.icon] || CheckCircle2;
                return (
                  <div
                    key={c.label}
                    className="flex items-center gap-4 py-3 border-b hairline last:border-0"
                  >
                    <div className="w-9 h-9 rounded-lg chip-blue flex items-center justify-center shrink-0">
                      <Icon className="w-4 h-4 text-[#5EC7F5]" />
                    </div>
                    <span className="text-[15px] text-slate-200">{c.label}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Instructor;
